import React from "react";

export default function LabelComponent({
  title,
  className,
  required,
  ...rest
}) {
  return (
    <label
      className={`gfield_label ${className}`}
      {...rest}
    >
      {title}
      {required && <span className="text-danger"> *</span>}
    </label>
  );
}
